import { render } from "./LoaderFullScreen.vue?vue&type=template&id=5d5fb1df&ts=true"
import script from "./LoaderFullScreen.vue?vue&type=script&lang=ts"
export * from "./LoaderFullScreen.vue?vue&type=script&lang=ts"

import "./LoaderFullScreen.vue?vue&type=style&index=0&id=5d5fb1df&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__